import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show && _ctx.text)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "tooltipContainer",
        class: "tw-fixed tw-z-[60] tw-max-w-[254px] tw-whitespace-normal tw-rounded-md tw-bg-gray-900 tw-px-3 tw-py-3 tw-text-xs tw-text-white tw-shadow-lg dark:tw-bg-gray-700",
        style: _normalizeStyle(_ctx.tooltipPosition)
      }, _toDisplayString(_ctx.text), 5))
    : _createCommentVNode("", true)
}